import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { BroadcastService } from './services/infrastructure/broadcaster.service';
import { ConfigService } from './services/infrastructure/config.service';
import { ConfirmDialogComponent } from './common/components/confirm-dialog/confirm-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { Observable, Observer } from 'rxjs';
import { MasterConstants } from './common/constants/master-constants';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard  {
  dataIsChanged = false;
  hasGeuChange = false;
  hasReturnChange = false;
  hasReturnRequestOnBehalfOfChange = false;
  hasSeedReturnEmailAddressChange = false;
  hasDateChange = false;
  hasSellerChange = false;
  hasCustomerChange = false;
  hasProductAdded = false;
  hasEditToolKitClick = false;
  isNavigateToBreadCrumb = false;
  transferTarget = false;
  emailUpdated = false;
  sellerUpdate = false;
  deliverToUpdated = false;
  requestTypeUpdated = false;
  freightHandlingCodeUpdated = false;
  branchPlantUpdated = false;
  additionalRequestDateRow = false;
  deliveryInstructionsUpdated = false;
  requestedDateUpdated = false;
  productQuantityUpdated = false;
  validateEvolveData: any;
  headerYear: any;
  headerCompany: any;
  hasCPPQtyChange = false;
  hasCPPDateChange = false;
  hasCPPDeliverToChange = false;
  hasCPPPOChange = false;
  hasCPPSplInsChange = false;
  hasCPPInsTypeChange = false;
  hasCPPCustPickupChange = false;
  hasCPPEmailAddressChange = false;
  labelYes: string;
  labelNo: string;
  hasCPPCOIDateChange = false;
  hasCPPCOIQtyChange = false;
  hasCropLossUnitChange = false;
  hasCropLossDataChange = false;
  hasSeedReplantUnitChange = false;
  hasSeedReplantDataChange = false;
  hasStockTransferDataChange = false;
  hasCIRChange = false;
  inEdit = false;
  hasGPDataChange = false;
  hasProductlabelDataChange = false;
  hasReconcileDataChange = false;

  constructor(private router: Router,
    public broadcastService: BroadcastService,
    private configService: ConfigService,
    public dialog: MatDialog) {
    this.broadcastService.on<any>(this.configService.DATA_CHANGE).subscribe((data) => {
      if (this.dataIsChanged == false) {
        // CPP Qty
        if (data.oldCPPQtyValue != undefined) {
          if (data.oldCPPQtyValue != data.newCPPQtyValue) {
            this.hasCPPQtyChange = true;
          }
          else {
            this.hasCPPQtyChange = false;
          }
        }

        // CPP Date
        if (data.oldCPPDateValue != undefined) {
          if (data.oldCPPDateValue != data.newCPPDateValue) {
            this.hasCPPDateChange = true;
          }
          else {
            this.hasCPPDateChange = false;
          }
        }

        // CPP Deliver To
        if (data.cppDeliverToValue != undefined) {
          if (data.cppDeliverToValue == true) {
            this.hasCPPDeliverToChange = true;
          }
          else {
            this.hasCPPDeliverToChange = false;
          }
        }

        // CPP Purchase Order
        if (data.cppPOValue != undefined) {
          if (data.cppPOValue == true) {
            this.hasCPPPOChange = true;
          }
          else {
            this.hasCPPPOChange = false;
          }
        }

        // CPP Special Instructions
        if (data.cppSplInsValue != undefined) {
          if (data.cppSplInsValue == true) {
            this.hasCPPSplInsChange = true;
          }
          else {
            this.hasCPPSplInsChange = false;
          }
        }

        // CPP Instructions Type
        if (data.cppInsTypeValue != undefined) {
          if (data.cppInsTypeValue == true) {
            this.hasCPPInsTypeChange = true;
          }
          else {
            this.hasCPPInsTypeChange = false;
          }
        }

        // CPP Email Address
        if (data.cppEmailAddressValue != undefined) {
          if (data.cppEmailAddressValue == true) {
            this.hasCPPEmailAddressChange = true;
          }
          else {
            this.hasCPPEmailAddressChange = false;
          }
        }

        // CPP Customer Pickup
        if (data.cppCustPickupValue != undefined) {
          if (data.cppCustPickupValue == true) {
            this.hasCPPCustPickupChange = true;
          }
          else {
            this.hasCPPCustPickupChange = false;
          }
        }

        // COI Qty
        if (data.oldCPPCOIQtyValue != undefined) {
          if (data.oldCPPCOIQtyValue != data.newCPPCOIQtyValue) {
            this.hasCPPCOIQtyChange = true;
          }
          else {
            this.hasCPPCOIQtyChange = false;
          }
        }
        // COI Date
        if (data.oldCPPCOIDateValue != undefined) {
          if (data.oldCPPCOIDateValue != data.newCPPCOIDateValue) {
            this.hasCPPCOIDateChange = true;
          }
          else {
            this.hasCPPCOIDateChange = false;
          }
        }

        // Crop Loss Units
        if (data.oldCropLossUnitValue != undefined) {
          if (data.oldCropLossUnitValue != data.newCropLossUnitValue) {
            this.hasCropLossUnitChange = true;
          }
          else {
            this.hasCropLossUnitChange = false;
          }
        }

        // Crop Loss data Change
        if (data.hasCropLossDataChange != undefined) {
          if (data.hasCropLossDataChange == true) {
            this.hasCropLossDataChange = true;
          }
          else {
            this.hasCropLossDataChange = false;
          }
        }

        // Seed Replant Units
        if (data.oldSeedReplantUnitValue != undefined) {
          if (data.oldSeedReplantUnitValue != data.newSeedReplantUnitValue) {
            this.hasSeedReplantUnitChange = true;
          }
          else {
            this.hasSeedReplantUnitChange = false;
          }
        }

        // Seed Replant data Change
        if (data.hasSeedReplantDataChange != undefined) {
          if (data.hasSeedReplantDataChange == true) {
            this.hasSeedReplantDataChange = true;
          }
          else {
            this.hasSeedReplantDataChange = false;
          }
        }

        // Seed Return Quantity Change
        if (data.oldReturnQty != undefined) {
          if (data.oldReturnQty != data.newReturnQty) {
            this.hasReturnChange = true;
          }
          else {
            this.hasReturnChange = false;
          }
          this.labelNo = data.labelNo;
        }
        // Seed Return Request on behalf of Change
        if (data.hasReturnRequestOnBehalfOfChange != undefined) {
          if (data.hasReturnRequestOnBehalfOfChange == true) {
            this.hasReturnRequestOnBehalfOfChange = true;
          }
          else {
            this.hasReturnRequestOnBehalfOfChange = false;
          }
          this.labelNo = data.labelNo;
        }

        // Seed Return Email Address
        if (data.seedReturnEmailAddressValue != undefined) {
          if (data.seedReturnEmailAddressValue == true) {
            this.hasSeedReturnEmailAddressChange = true;
          }
          else {
            this.hasSeedReturnEmailAddressChange = false;
          }
          this.labelNo = data.labelNo;
        }

        // Seed Return Notes
        if (data.seedReturnValue != undefined) {
          if (data.seedReturnValue == true) {
            this.hasReturnChange = true;
          }
          else {
            this.hasReturnChange = false;
          }
          this.labelNo = data.labelNo;
        }

        if (data.oldGeuValue != undefined) {
          if (data.oldGeuValue != data.newGeuValue) {
            this.hasGeuChange = true;
          }
          else {
            this.hasGeuChange = false;
          }
        }

        if (data.oldDateValue != undefined) {
          if (new Date(data.oldDateValue) != new Date(data.newDateValue)) {
            this.hasDateChange = true;
          }
          else {
            this.hasDateChange = false;
          }
        }

        if (data.oldSellerValue != undefined
          || data.oldSellerValue == null) {
          if (data.oldSellerValue != data.newSellerValue) {
            this.hasSellerChange = true;
          }
          else {
            this.hasSellerChange = false;
          }
        }

        if (data.oldCustomerPoValue != undefined) {
          if (data.oldCustomerPoValue != data.newCustomerPoValue) {
            this.hasCustomerChange = true;
          }
          else {
            this.hasCustomerChange = false;
          }
        }
        if (data.productCount != undefined) {
          if (data.productCount > 0) {
            this.hasProductAdded = true;
            if (data.isSOT) {
              this.labelNo = data.labelNo;
            } else {
              this.labelNo = '';
            }
          }
          else {
            this.hasProductAdded = false;
          }
        }

        if (data.editToolKitClick != undefined) {
          if (data.editToolKitClick == true) {
            this.hasEditToolKitClick = true;
          }
          else {
            this.hasEditToolKitClick = false;
          }
          this.labelNo = data.labelNo;
        }

        if (data.transferTarget != undefined) {
          if (data.transferTarget == true) {
            this.transferTarget = true;
          }
          else {
            this.transferTarget = false;
          }
        }

        if (data.emailUpdated != undefined) {
          if (data.emailUpdated == true) {
            this.emailUpdated = true;
          }
          else {
            this.emailUpdated = false;
          }
        }

        if (data.sellerUpdate != undefined) {
          if (data.sellerUpdate == true) {
            this.sellerUpdate = true;
          }
          else {
            this.sellerUpdate = false;
          }
        }

        if (data.requestedDateUpdated != undefined) {
          if (data.requestedDateUpdated == true) {
            this.requestedDateUpdated = true;
          }
          else {
            this.requestedDateUpdated = false;
          }
        }

        if (data.deliverToUpdated != undefined) {
          if (data.deliverToUpdated == true) {
            this.deliverToUpdated = true;
          }
          else {
            this.deliverToUpdated = false;
          }
        }

        if (data.branchPlantUpdated != undefined) {
          if (data.branchPlantUpdated == true) {
            this.branchPlantUpdated = true;
          }
          else {
            this.branchPlantUpdated = false;
          }
        }

        // additionalRequestDateRow

        if (data.additionalRequestDateRow != undefined) {
          if (data.additionalRequestDateRow == true) {
            this.additionalRequestDateRow = true;
          }
          else {
            this.additionalRequestDateRow = false;
          }
        }

        if (data.requestTypeUpdated != undefined) {
          if (data.requestTypeUpdated == true) {
            this.requestTypeUpdated = true;
          }
          else {
            this.requestTypeUpdated = false;
          }
        }

        if (data.freightHandlingCodeUpdated != undefined) {
          if (data.freightHandlingCodeUpdated == true) {
            this.freightHandlingCodeUpdated = true;
          }
          else {
            this.freightHandlingCodeUpdated = false;
          }
        }

        if (data.deliveryInstructionsUpdated != undefined) {
          if (data.deliveryInstructionsUpdated == true) {
            this.deliveryInstructionsUpdated = true;
          }
          else {
            this.deliveryInstructionsUpdated = false;
          }
        }

        if (data.productQuantityUpdated != undefined) {
          if (data.productQuantityUpdated == true) {
            this.productQuantityUpdated = true;
          }
          else {
            this.productQuantityUpdated = false;
          }
        }

        // Stock Transfer Change
        if (data.oldStockRquestedQty != undefined) {
          if (data.oldStockRquestedQty != data.newStockRequestedQty) {
            this.hasStockTransferDataChange = true;
            this.labelNo = data.labelNo;
          }
          else {
            this.hasStockTransferDataChange = false;
            this.labelNo = '';
          }
        }

        // Customer Inventory Report
        if (data.cirDataChange != undefined) {
          this.hasCIRChange = data.cirDataChange == true;
          this.labelNo = data.labelNo;
        }

        // Grower Program
        if (data.gpDataChange != undefined) {
          this.hasGPDataChange = data.gpDataChange == true;
          this.labelNo = data.labelNo;
        }

        // Order Reconcile
        if (data.reconcileDataChanged != undefined) {
          this.hasReconcileDataChange = data.reconcileDataChanged == true;
          this.labelNo = data.labelNo;
        }
        // Product Label
        if (data.plDataChange != undefined) {
          this.hasProductlabelDataChange = data.plDataChange == true;
          this.labelNo = data.labelNo;
        }

        this.labelYes = data.labelYes;
        this.inEdit = data.inEdit;

        if (this.hasGeuChange || this.hasDateChange || this.hasSellerChange || this.hasCustomerChange ||
          this.hasProductAdded || this.hasEditToolKitClick || this.transferTarget || this.emailUpdated || this.sellerUpdate || this.deliveryInstructionsUpdated ||
          this.productQuantityUpdated || this.deliverToUpdated || this.branchPlantUpdated || this.requestTypeUpdated || this.freightHandlingCodeUpdated ||
          this.hasCPPQtyChange || this.hasCPPDateChange || this.hasCPPDeliverToChange || this.hasCPPPOChange || this.hasCPPSplInsChange || this.hasCPPInsTypeChange ||
          this.hasCPPEmailAddressChange || this.hasCPPCustPickupChange || this.hasReturnChange || this.hasReturnRequestOnBehalfOfChange || this.hasSeedReturnEmailAddressChange ||
          this.hasCropLossUnitChange || this.hasCropLossDataChange || this.hasSeedReplantUnitChange || this.hasSeedReplantDataChange || this.additionalRequestDateRow ||
          this.hasStockTransferDataChange || this.hasCIRChange || this.hasGPDataChange || this.hasProductlabelDataChange || this.hasReconcileDataChange) {
          this.dataIsChanged = true;
        }
        else {
          this.dataIsChanged = false;
        }
      }

      if ((data.updateButtonClick != undefined && data.updateButtonClick == true)
        || (data.cancelBtnClick != undefined && data.cancelBtnClick == true)) {
        this.dataIsChanged = false;
        this.hasGeuChange = false;
        this.hasReturnChange = false;
        this.hasDateChange = false;
        this.hasSellerChange = false;
        this.hasCustomerChange = false;
        this.hasProductAdded = false;
        this.hasEditToolKitClick = false;
        this.transferTarget = false;
        this.emailUpdated = false;
        this.sellerUpdate = false;
        this.hasCropLossUnitChange = false;
        this.hasCropLossDataChange = false;
        this.hasSeedReplantUnitChange = false;
        this.hasSeedReplantDataChange = false;
        this.hasStockTransferDataChange = false;
        this.hasCIRChange = false;
      }

      this.broadcastService.broadcast(this.configService.DATA_CHANGE_ADDED, { hasChangeAdded: this.dataIsChanged });
    });

    this.broadcastService.on<any>(this.configService.BREADCRUMB_CLICK).subscribe((data) => {
      if (data.breadCrumbClick != undefined
        && data.breadCrumbClick == true) {
        this.isNavigateToBreadCrumb = true;
      }
    });
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> {
    if (localStorage[MasterConstants.HEADER_COMPANY_CODE]) {
      this.headerCompany = JSON.parse(localStorage[MasterConstants.HEADER_COMPANY_CODE]);
    }

    let dialogRef = null;

    if (this.dataIsChanged == true) {
      // Added Popup
      // var title = "You will lose your unsaved changes!";
      // var message = "Your current order has unsaved changes that you'll lose by moving to another order. If that's alright you may continue, otherwise save your changes and switch to another order after.";
      const title = 'Leave without saving?';
      const message = '';
      dialogRef = this.dialog.open(ConfirmDialogComponent, {
        disableClose: true,
        width: '480px',
        data: {
          title: title, message: message,
          labelYes: this.labelYes ? this.labelYes : 'Yes',
          labelNo: this.labelNo ? this.labelNo : 'No, go back to Order',
          dialogType: 'confirm'
        }
      });
    }

    return Observable.create((observer: Observer<boolean>) => {
      if (dialogRef != null) {
        dialogRef.afterClosed().subscribe(result => {
          //const isLogOut = localStorage[MasterConstants.IS_LOGOUT];
          // If user selected Yes
          if (result == true) {
            this.dataIsChanged = false;

            if (this.isNavigateToBreadCrumb == true) {
              this.broadcastService.broadcast(this.configService.NAVIGATE_TO_BREADCRUMB, { naigateToBreadCrumb: true });
              this.broadcastService.broadcast(this.configService.DATA_CHANGE_ADDED, { hasChangeAdded: this.dataIsChanged });
            }

            if (this.inEdit === true) {
              this.broadcastService.broadcast(this.configService.IN_EDIT, { inEdit: this.inEdit });
            }

            this.hasGeuChange = false;
            this.hasReturnChange = false;
            this.hasDateChange = false;
            this.hasSellerChange = false;
            this.hasCustomerChange = false;
            this.hasProductAdded = false;
            this.hasEditToolKitClick = false;
            this.isNavigateToBreadCrumb = false;
            this.transferTarget = false;
            this.emailUpdated = false;
            this.sellerUpdate = false;
            this.hasCIRChange = false;
            this.labelNo = "";

            //if (isLogOut == 'false') {
              if (this.inEdit === true) {
                observer.next(false);
              } else {
                observer.next(true);
              }
              this.inEdit = false;
              observer.complete();
            //}
            //else if (isLogOut == 'true') {
            //  this.broadcastService.broadcast(this.configService.SIGN_OUT, { isSignOut: true });
            //  if (localStorage[MasterConstants.EVOLVE_ACCESS]) {
            //    this.validateEvolveData = JSON.parse(localStorage[MasterConstants.EVOLVE_ACCESS]);
            //  }

            //  if (localStorage[MasterConstants.HEADER_CROP_YEAR]) {
            //    this.headerYear = JSON.parse(localStorage[MasterConstants.HEADER_CROP_YEAR]);
            //  }

            //  if (localStorage[MasterConstants.HEADER_COMPANY_CODE]) {
            //    this.headerCompany = JSON.parse(localStorage[MasterConstants.HEADER_COMPANY_CODE]);
            //  }

            //  localStorage.clear();
            //  this.deleteAllCookies();
            //  localStorage[MasterConstants.EVOLVE_ACCESS] = JSON.stringify(this.validateEvolveData);
            //  localStorage[MasterConstants.IS_RELOAD] = 'true';
            //  localStorage[MasterConstants.HEADER_CROP_YEAR] = JSON.stringify(this.headerYear);
            //  localStorage[MasterConstants.HEADER_COMPANY_CODE] = JSON.stringify(this.headerCompany);

            //  observer.next(true);
            //  observer.complete();
            //}
            //else {
            //  if (localStorage[MasterConstants.IS_RELOAD] = 'true'
            //    && isLogOut != undefined) {
            //    localStorage[MasterConstants.IS_RELOAD] = 'false';
            //    observer.next(true);
            //  }
            //  else {
            //    observer.next(false);
            //  }
            //  observer.complete();
            //}
          }
          //else {
          //  localStorage[MasterConstants.IS_LOGOUT] = 'false';
          //  this.broadcastService.broadcast(this.configService.SIGN_OUT, { isSignOut: false });
          //  observer.next(false);
          //  observer.complete();
          //}
        });
      }
      else {
        const token = localStorage.getItem('token');
        if (token === undefined || token === null) {
          if (next.url) {
            const pathInfo = next.url.map(x => x.path).join('/');
            if (pathInfo.indexOf('cc/landing') === -1 && pathInfo.indexOf('logout') === -1) {
              localStorage.setItem('url-path', pathInfo);
            }
          }
        }
        //const isLogOut = localStorage[MasterConstants.IS_LOGOUT];
        //if (isLogOut == 'false') {
          this.dataIsChanged = false;
          this.hasGeuChange = false;
          this.hasReturnChange = false;
          this.hasDateChange = false;
          this.hasSellerChange = false;
          this.hasCustomerChange = false;
          this.hasProductAdded = false;
          this.hasEditToolKitClick = false;
          this.isNavigateToBreadCrumb = false;
          this.transferTarget = false;
          this.emailUpdated = false;
          this.sellerUpdate = false;
          this.hasCIRChange = false;
          observer.next(true);
          observer.complete();
        //}
        //else if (isLogOut == 'true') {
        //  this.broadcastService.broadcast(this.configService.SIGN_OUT, { isSignOut: true });
        //  if (localStorage[MasterConstants.EVOLVE_ACCESS]) {
        //    this.validateEvolveData = JSON.parse(localStorage[MasterConstants.EVOLVE_ACCESS]);
        //  }

        //  if (localStorage[MasterConstants.HEADER_CROP_YEAR]) {
        //    this.headerYear = JSON.parse(localStorage[MasterConstants.HEADER_CROP_YEAR]);
        //  }

        //  if (localStorage[MasterConstants.HEADER_COMPANY_CODE]) {
        //    this.headerCompany = JSON.parse(localStorage[MasterConstants.HEADER_COMPANY_CODE]);
        //  }

        //  this.deleteAllCookies();
        //  localStorage.clear();

        //  // localStorage[MasterConstants.EVOLVE_ACCESS] = JSON.stringify(this.validateEvolveData);
        //  // localStorage[MasterConstants.IS_RELOAD] = "true";
        //  // localStorage[MasterConstants.HEADER_CROP_YEAR] = JSON.stringify(this.headerYear);
        //  // localStorage[MasterConstants.HEADER_COMPANY_CODE] = JSON.stringify(this.headerCompany);
        //  observer.next(true);
        //  observer.complete();
        //}
        //else {
        //  if (localStorage[MasterConstants.IS_RELOAD] = 'true'
        //    && isLogOut != undefined) {
        //    localStorage[MasterConstants.IS_RELOAD] = 'false';
        //    observer.next(true);
        //  }
        //  else {
        //    observer.next(false);
        //  }
        //  observer.complete();
        //}
      }
    });
  }

  deleteAllCookies() {
    const cookies = document.cookie.split(';');
    for (let i = 0; i < cookies.length; i++) {
      this.deleteCookie(cookies[i].split('=')[0]);
    }
  }

  deleteCookie(name) {
    this.setCookie(name, '', -1);
  }

  setCookie(name, value, expirydays) {
    const d = new Date();
    d.setTime(d.getTime() + (expirydays * 24 * 60 * 60 * 1000));
    const expires = 'expires=' + d.toUTCString();
    document.cookie = name + '=' + value + '; ' + expires;
  }
}
